export default "__VITE_PUBLIC_ASSET__3bb0a7eb__"